import PromptsSidebar from '../components/prompts/side/PromptsSidebar';
import PromptModals from '../components/prompts/views/diffmerge/PromptModals';
import { useState } from 'react';
import { useUtilityContext } from '@Context/prompt-toolbox/UtilityContext';
import DiffMergeView from '../components/prompts/views/diffmerge';
import AddPromptView from '../components/prompts/views/new';
import ImportLibraryView from '../components/prompts/views/library';

const Prompts = () => {
  const [toggleSidebar, setToggleSidebar] = useState(true);
  const { view } = useUtilityContext();

  return (
    <div className="flex h-[100vh] flex-col overflow-hidden">
      <div
        className={`${toggleSidebar ? 'flex md:hidden' : 'hidden'} pointer-events-none absolute z-[41] h-full w-full bg-black opacity-50`}
      />
      <div className="relative flex h-full w-full flex-col overflow-hidden md:block md:p-4">
        <div className="flex h-full w-full flex-row justify-end md:relative">
          {/* LIST */}
          <div
            className={`absolute left-0 top-0 h-full w-2/3 overflow-hidden md:w-1/5 ${toggleSidebar ? 'z-[41] md:z-40' : 'z-10 hidden md:block'} `}
          >
            <PromptsSidebar
              setToggleSidebar={setToggleSidebar}
              toggled={toggleSidebar}
            />
          </div>

          {/* MAIN */}
          <div
            className={`relative z-40 flex h-full flex-col bg-white transition-all duration-300 ease-in-out ${
              toggleSidebar ? 'ml-1/5 w-full md:w-4/5' : 'ml-0 w-full'
            }`}
          >
            {view === 'Diff' && (
              <DiffMergeView
                toggled={toggleSidebar}
                onToggleSidebar={() => setToggleSidebar((prev) => !prev)}
              />
            )}

            {view === 'New' && (
              <AddPromptView
                toggled={toggleSidebar}
                onToggleSidebar={() => setToggleSidebar((prev) => !prev)}
              />
            )}

            {view === 'Library' && (
              <ImportLibraryView
                toggled={toggleSidebar}
                onToggleSidebar={() => setToggleSidebar((prev) => !prev)}
              />
            )}
          </div>
        </div>
      </div>
      <PromptModals />
    </div>
  );
};

export default Prompts;
